'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const BankCardIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M2.89995 12.1H15.7999M17.3999 16L18.7999 16.3C19.2999 16.4 19.8999 16 19.9999 15.5L21.2999 8.29997C21.3999 7.79997 20.9999 7.19997 20.4999 7.09997L9.39995 5.09997C8.79995 4.99997 8.19995 5.39997 8.09995 5.99997L7.79995 8.19997M14.9999 18.9H3.69995C3.09995 18.9 2.69995 18.5 2.69995 17.9V10.6C2.69995 9.99997 3.09995 9.59997 3.69995 9.59997H14.9999C15.5999 9.59997 15.9999 9.99997 15.9999 10.6V17.9C15.9999 18.4 15.5999 18.9 14.9999 18.9Z",
        stroke: "currentColor"
      }
    )
  }
);
const VpBankCardIcon = forwardRef(BankCardIcon);

export { VpBankCardIcon as default };
